export interface AudienceDefinition {
  id: string;
  label: string;
  description: string;
  usesWhen: string[];
}

export const AUDIENCE_DEFINITIONS: AudienceDefinition[] = [
  {
    id: 'vardagskocken',
    label: 'Vardagskocken (familj & hem)',
    description: 'Personer som lagar mat hemma och vill ha god, enkel och pålitlig vardagsmat.',
    usesWhen: [
      'Recept & vardagsinspiration',
      'Kampanjer i butik',
      'Pris- eller erbjudandekommunikation',
      'Bred konsumentkommunikation'
    ]
  },
  {
    id: 'foodies',
    label: 'Matintresserade / Foodies',
    description: 'Personer som söker inspiration, kvalitet, ursprung och nya smaker.',
    usesWhen: [
      'Varumärkesbyggande kommunikation',
      'Storytelling & ursprung',
      'Premium- eller specialprodukter',
      'Sociala medier'
    ]
  },
  {
    id: 'tradition_trygghet',
    label: 'Tradition & trygghet',
    description: 'Trogna konsumenter som värderar igenkänning, kvalitet och erfarenhet.',
    usesWhen: [
      'Printannonser',
      'Klassiker i sortimentet',
      'Kommunikation om varumärkets historia',
      'Långsiktig varumärkesnärvaro'
    ]
  },
  {
    id: 'restaurangkok',
    label: 'Restaurangkök',
    description: 'Professionella restaurangkök med fokus på smak, effektivitet och jämn kvalitet.',
    usesWhen: [
      'Foodservice-kommunikation',
      'Produktlansering mot restaurang',
      'Branschmedia',
      'Säljmaterial till restaurang'
    ]
  },
  {
    id: 'storkok_offentlig',
    label: 'Storkök & offentlig sektor',
    description: 'Kök inom skola, vård och offentlig verksamhet med fokus på volym och funktion.',
    usesWhen: [
      'Upphandling',
      'Volymprodukter',
      'Närings- och funktionskommunikation',
      'Pris & leveranssäkerhet är viktigast'
    ]
  },
  {
    id: 'grossist_inkop',
    label: 'Grossist / inköp',
    description: 'Inköpare, category managers och sortimentsansvariga.',
    usesWhen: [
      'Listning & sortimentsdialog',
      'Säljpresentationer',
      'Kategoristrategi',
      'Kampanjförhandling'
    ]
  },
  {
    id: 'konsument_handel',
    label: 'Både konsument & handel',
    description: 'Kommunikation som ska fungera både mot konsument och handel.',
    usesWhen: [
      'Större kampanjer',
      'Produktlanseringar',
      'Kedjeinitiativ',
      'När både konsument-pull och handels-push behövs'
    ]
  }
];

